"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomButtonGroupInput = void 0;
var React = require("react");
var CustomButtonGroupInput = /** @class */ (function (_super) {
    __extends(CustomButtonGroupInput, _super);
    function CustomButtonGroupInput(props) {
        var _this = _super.call(this, props) || this;
        _this.inputRef = React.createRef();
        _this.handleOnClickEvent = _this.handleOnClickEvent.bind(_this);
        return _this;
    }
    CustomButtonGroupInput.prototype.render = function () {
        return (React.createElement("label", { className: "btn btn-primary ".concat(this.getCssClass()), onClick: this.handleOnClickEvent },
            React.createElement("input", { type: "radio", ref: this.inputRef, name: this.props.name, key: this.props.id, value: this.props.id, checked: this.props.isChecked, style: { "display": "none" }, onChange: this.props.onChange }),
            this.props.value));
    };
    CustomButtonGroupInput.prototype.getCssClass = function () {
        return "".concat(this.props.isChecked ? "active" : "", " ").concat(this.props.cssClass);
    };
    CustomButtonGroupInput.prototype.handleOnClickEvent = function (event) {
        this.inputRef.current.click();
    };
    return CustomButtonGroupInput;
}(React.Component));
exports.CustomButtonGroupInput = CustomButtonGroupInput;
//# sourceMappingURL=CustomButtonGroupInput.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/plugin-journey/dist/widgets/components/CustomButtonGroupInput.js
// module id = 2363
// module chunks = 0